import React from "react";
import AttachFiles from './AttachFiles';

export const QuillToolbar = ({files,removeFile,bind,screen}) => (
    <div className="quiill-toolbar-mail">
        <div id="scroll_files" className="message-box-mail__container-attach-files">
            {files.map((file, index) => 
                <AttachFiles attach={file} removeFile={removeFile} index={index} bind={bind} />
            )}
        </div>
        <div id={"toolbar"+screen}>
            <span className="ql-formats">
                <button className="ql-bold" id="buttons-quill" />
                <button className="ql-italic" id="buttons-quill" />
                <button className="ql-underline" id="buttons-quill" />
                <button className="ql-link" id="buttons-quill" />
                <button className="ql-image" id="buttons-quill" />
            </span>
        </div>
    </div>
);

export default QuillToolbar;
